// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function(g) {
  'use strict';
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for(var x = 0; x < vendors.length && !g.requestAnimationFrame; ++x) {
    g.requestAnimationFrame = g[vendors[x]+'RequestAnimationFrame'];
    g.cancelAnimationFrame = g[vendors[x]+'CancelAnimationFrame'] 
                          || g[vendors[x]+'CancelRequestAnimationFrame'];
  }

  if (!g.requestAnimationFrame)
    g.requestAnimationFrame = function(callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = g.setTimeout(function() { callback(currTime + timeToCall); }, 
        timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    }
  ;

  if (!g.cancelAnimationFrame)
    g.cancelAnimationFrame = function(id) {
        clearTimeout(id);
    }
  ;
}((this && this.window) || global));